export default "__VITE_ASSET__CkPj0$ui__"